import { combineReducers, Reducer } from '@reduxjs/toolkit';

import appReducer, { appInitialState, AppActions } from './app/app.slice';
import { AppSelectors } from './app/app.selectors';

import collectionReducer, {
  collectionInitialState,
  CollectionActions,
} from './collection/collection.slice';
import { CollectionSelectors } from './collection/collection.selectors';

import dashboardReducer, {
  dashboardInitialState,
  DashboardActions,
} from './dashboard/dashboard.slice';
import { DashboardSelectors } from './dashboard/dashboard.selectors';

import transactionReducer, {
  transactionInitialState,
  TransactionActions,
} from './transaction/transaction.slice';

import settingsReducer, {
  settingsInitialState,
  SettingsActions,
} from './settings/settings.slice';
import { SettingsSelectors } from './settings/settings.selectors';

import walletReducer, {
  walletInitialState,
  WalletActions,
} from './wallet/wallet.slice';
import { WalletSelectors } from './wallet/wallet.selectors';

import { RootState } from '@types';

const rootReducer: Reducer<RootState> = combineReducers({
  app: appReducer,
  collection: collectionReducer,
  dashboard: dashboardReducer,
  settings: settingsReducer,
  transaction: transactionReducer,
  wallet: walletReducer,
});

export default rootReducer;

export { AppActions, AppSelectors, appInitialState };
export { CollectionActions, CollectionSelectors, collectionInitialState };
export { DashboardActions, DashboardSelectors, dashboardInitialState };
export { SettingsActions, SettingsSelectors, settingsInitialState };
export { TransactionActions, transactionInitialState };
export { WalletActions, WalletSelectors, walletInitialState };
